import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";
import { useState } from "react";
import "../../../css/common.css";
import Header from "./Header";
import shaHash from "../../../lib/logic/shaHash";
import CopyButton from "../../../lib/components/CopyButton";
import AdComponent from "../../../lib/components/AdComponent";

const SHAhash = (props) => {
  const { title, description, keywords } = { ...props };
  const [res, setRes] = useState("");
  const [hashType, setHashType] = useState("sha1");
  const [originalText, setOriginalText] = useState("");
  const handleclick = () => {
    setRes(shaHash(originalText,hashType))
  };
  const handleChange = (e)=>{
    setHashType(e.target.value);

  }

  return (
    <Box height="100%">
      <Header keywords={keywords} title={title} description={description}></Header>
      <AdComponent fixed={true} />
      <Box height="100%" display="flex" alignItems="top" paddingTop={5}>
        <Grid container spacing={0}>
          <Grid item xs={5}>
            <TextField
              className="inputM"
              value={originalText}
              label="Input"
              placeholder="Input text here"
              variant="outlined"
              multiline
              minRows={6}
              maxRows={15}
              onChange={(e) => {
                setOriginalText(e.target.value);
              }}
            ></TextField>
          </Grid>

          <Grid item xs={2}>
            <Stack alignItems="center" spacing={2}>
              <FormControl variant="standard" sx={{minWidth:150}}>
                <InputLabel>Hashing Algorithm</InputLabel>
              <Select
              value={hashType}
              label = "Hashing Algorithm"
              onChange={handleChange}
              >
                <MenuItem value={"sha1"}>SHA-1</MenuItem>
                <MenuItem value={"sha224"}>SHA-225</MenuItem>
                <MenuItem value={"sha256"}>SHA-256</MenuItem>
                <MenuItem value={"sha3"}>SHA-3</MenuItem>
                <MenuItem value={"sha384"}>SHA-384</MenuItem>
                <MenuItem value={"sha512"}>SHA-512</MenuItem>
              </Select>
              </FormControl>
              <Button
                className="btnwidth"
                variant="contained"
                onClick={() => handleclick()}
              >
                Calculate
              </Button>
            </Stack>
          </Grid>

          <Grid item xs={5}>
            <TextField
              className="inputM"
              label="Output"
              variant="outlined"
              multiline
              minRows={6}
              maxRows={15}
              value={res}
            ></TextField>
            <CopyButton text={res}/>
          </Grid>
        </Grid>
      </Box>
      <AdComponent fixed={false} />
    </Box>
  );
};

export default SHAhash;
